import "./CustomTabs.scss";

interface Tab {
	key: string;
	label: string;
	disabled?: boolean;
}

interface CustomTabsProps {
	tabs: Tab[];
	activeTab: string;
	setActiveTab: (key: string) => void;
}

const CustomTabs = ({ tabs, activeTab, setActiveTab }: CustomTabsProps) => {
	return (
		<div className="custom-tabs-container">
			<div className="custom-tabs-wrapper">
				{tabs?.map((tab) => (
					<button
						key={tab.key}
						onClick={() => setActiveTab(tab.key)}
						disabled={tab.disabled}
						className={`custom-tab w-full ${
							activeTab === tab.key ? 
							"custom-tab--active" : 
							tab.disabled ? 
							"" :
							"custom-tab--inactive"
						}`}
					>
						{tab.label}
					</button>
				))}
			</div>
		</div>
	);
};

export default CustomTabs;
